import { HomeGroupRemoveIcon } from './HomeGroupRemoveIcon';

/**
 * author: Michael Irigoyen
 * id A4438B5F-FA4C-4C73-8514-3D0364BBB7A5
 * name home-group-remove
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-group-remove.svg
 * tags
 * - Home Automation 
 */
export const HouseGroupRemoveIcon = HomeGroupRemoveIcon;
export default HouseGroupRemoveIcon